import { IColumn } from '@repo/ui';

export const makeActivitiesSummarizedByTaskColumns = (): IColumn[] => {
  return [
    {
      title: 'Tarefa',
      dataKey: 'task',
      width: 270,
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-primary fw-semibold">
            <span>{rowData.task}</span>
          </div>
        );
      },
    },
    {
      title: 'Atividades',
      dataKey: 'activities',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <span>{rowData.activities}</span>
          </div>
        );
      },
    },
    {
      title: 'Finalizadas',
      dataKey: 'finished',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <u className="fw-semibold">{rowData?.finished?.qtd}</u>
            <span className="mx-1 fw-normal">
              ({rowData?.finished?.percent})
            </span>
          </div>
        );
      },
    },
    {
      title: 'Validadas',
      dataKey: 'validated',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <u className="fw-semibold">{rowData?.validated?.qtd}</u>
            <span className="mx-1 fw-normal">
              ({rowData?.validated?.percent})
            </span>
          </div>
        );
      },
    },
    {
      title: 'Perdidas',
      dataKey: 'missed',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <u className="fw-semibold">{rowData?.missed?.qtd}</u>
            <span className="mx-1 fw-normal">({rowData?.missed?.percent})</span>
          </div>
        );
      },
    },
    {
      title: 'Perdidas Justificadas',
      dataKey: 'missedJustified',
      cellRenderer: ({ rowData }) => {
        return (
          <div className="text-end">
            <u className="fw-semibold">{rowData?.missedJustified?.qtd}</u>
            <span className="mx-1 fw-normal">
              ({rowData?.missedJustified?.percent})
            </span>
          </div>
        );
      },
    },
    {
      title: 'Ch Total',
      dataKey: 'workload',
      cellRenderer: ({ rowData }) => (
        <div className="text-end">{rowData?.workload || '--'}</div>
      ),
    },
    {
      title: 'CH Validada',
      dataKey: 'workloadValidated',
      cellRenderer: ({ rowData }) => (
        <div className="text-end">{rowData?.workloadValidated || '--'}</div>
      ),
    },
  ];
};
